import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e7698bd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "status-item"
};
const _hoisted_2 = {
  key: 1,
  class: "content"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 3,
  class: "translate-box"
};
const _hoisted_5 = {
  class: "copy-and-apply-keywords"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "apply-keywords-popover-content"
}, [/*#__PURE__*/_createElementVNode("span", null, " Omny AI has carefully selected keywords to optimize your Amazon Seller Central search terms, ensuring maximum effectiveness and visibility. ")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tiny_omny_icon = _resolveComponent("tiny-omny-icon");
  const _component_amazon_icon = _resolveComponent("amazon-icon");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_textarea = _resolveComponent("app-textarea");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_apply_keywords_icon = _resolveComponent("apply-keywords-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['edit-text-modal-content', $props.type])
  }, [_createElementVNode("div", {
    class: _normalizeClass(['title', $props.type])
  }, [$props.type == 'omny' ? (_openBlock(), _createBlock(_component_tiny_omny_icon, {
    key: 0,
    width: "20",
    height: "20",
    color: "#736bc9"
  })) : (_openBlock(), _createBlock(_component_amazon_icon, {
    key: 1,
    width: "20",
    height: "20",
    color: "#E94E1B"
  })), _createTextVNode(" " + _toDisplayString($props.type == 'omny' ? 'Draft' : 'Currently on Amazon'), 1)], 2), _createElementVNode("div", {
    class: _normalizeClass(['body', $props.type, {
      disabled: !$props.isValid
    }])
  }, [_createVNode(_component_app_icon, {
    size: "16",
    icon: $options.validation.status == 'success' ? 'check-v2' : $options.validation.status == 'warning' ? 'product-score-warning' : 'product-score-bad',
    color: $options.validation.status == 'success' ? '#22863d' : $options.validation.status == 'warning' ? '#d7aa0f' : '#ffffff',
    id: `edit-popup-content-validation-${$props.type}`,
    class: "score"
  }, null, 8, ["icon", "color", "id"]), _createVNode(_component_app_popover, {
    target: `edit-popup-content-validation-${$props.type}`,
    "auto-width": "",
    placement: "top",
    "custom-class": "score-popover"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_app_icon, {
      size: "16",
      icon: $options.validation.status == 'success' ? 'check-v2' : $options.validation.status == 'warning' ? 'product-score-warning' : 'product-score-bad',
      color: $options.validation.status == 'success' ? '#22863d' : $options.validation.status == 'warning' ? '#d7aa0f' : '#ffffff'
    }, null, 8, ["icon", "color"]), _createElementVNode("span", null, _toDisplayString($options.validation.text), 1)])]),
    _: 1
  }, 8, ["target"]), $props.type == 'omny' && !$props.show_comparism ? (_openBlock(), _createBlock(_component_app_textarea, {
    key: 0,
    modelValue: $options.editText,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.editText = $event),
    onScroll: _ctx.handleScroll,
    class: "content",
    v2: "",
    background: "#fff"
  }, null, 8, ["modelValue", "onScroll"])) : _createCommentVNode("", true), $props.type == 'amazon' && !$props.show_comparism ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.original), 1)) : _createCommentVNode("", true), $props.show_comparism ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "content",
    innerHTML: $props.comparism,
    style: {
      "display": "initial"
    },
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleClickOnComparism && $options.handleClickOnComparism(...args))
  }, null, 8, _hoisted_3)) : _createCommentVNode("", true), $props.show_translation ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_app_icon, {
    icon: "translate",
    size: 13.33,
    color: "#ADADAD",
    style: {
      "margin-top": "3.33px"
    }
  }), _createTextVNode(" " + _toDisplayString($props.translation), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['bottom', $props.type])
  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "copy-icon",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onCopy && $options.onCopy(...args))
  }, [!$data.copied ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    icon: "copy",
    size: "16",
    color: $props.type == 'omny' ? '#736BC9' : '#FF8933'
  }, null, 8, ["color"])) : (_openBlock(), _createBlock(_component_app_icon, {
    key: 1,
    icon: "check",
    size: 13,
    color: "#22863D"
  }))]), _withDirectives(_createElementVNode("div", {
    class: "apply-keywords",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.onApplyKeywords && $options.onApplyKeywords(...args)),
    id: "edit-modal-apply-keywords"
  }, [$props.apply_keywords_loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_apply_keywords_icon, {
    key: 1
  })), _createTextVNode(" Apply suggested keywords ")], 512), [[_vShow, $props.type == 'omny' && $props.content_type == 'generic_keyword']]), _createVNode(_component_app_popover, {
    target: 'edit-modal-apply-keywords',
    "auto-width": "",
    placement: "top",
    "custom-class": "apply-keywords-popover"
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })]), _createElementVNode("div", {
    class: _normalizeClass(["character-limit-box", {
      red: !$props.isValid
    }])
  }, [$props.type == 'omny' ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    icon: "draft",
    color: "#736BC9",
    size: "14"
  })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.characterCountInfo), 1)], 2)], 2)], 2)], 2);
}